import * as amplitude from "@amplitude/analytics-browser"

import { getConsentsData } from "./analytics-consents"
import setUserProperties from "./analytics-identify"
import { sendEventToOptimizely } from "./analytics-optimizely"

const userProperties = {
  "First name": "firstname",
  "Last name": "lastname",
  Email: "email",
  Company: "company",
}

const eventProperties = {
  "Job title": "jobtitle",
  "Number of employees": "numemployees",
  "Interest selection": "website_interest_sales_picklist",
  "Email opt in": "web_email_opt_in",
  "Is default CTA": "default_cta",
}

export default async function analyticsFormSubmit(
  formId: string,
  data?: {
    redirectUrl?: string
    submissionValues: Record<string, string>
  }
) {
  const filteredFormData = (
    properties: Record<string, string>
  ): Record<string, string> =>
    Object.entries(properties).reduce(
      (acc: Record<string, string>, [key, value]) => {
        if (data?.submissionValues[value] !== undefined) {
          acc[key] = data.submissionValues[value]
        }
        return acc
      },
      {}
    )

  setUserProperties({ ...filteredFormData(userProperties) })
  sendEventToOptimizely("marketing_form_submitted", {
    "Form ID": formId,
    "Form provider": "hubspot",
    ...(data?.submissionValues["numemployees"] !== undefined && {
      "Number of employees": data.submissionValues["numemployees"],
    }), // Temp: used for direct-to-book Optimizely experiment.
  })

  await amplitude.track("Marketing Form Submitted", {
    ...filteredFormData(userProperties),
    ...filteredFormData(eventProperties),
    "Form ID": formId,
    "Form provider": "hubspot",
    ...getConsentsData(),
  }).promise
}
